import useSWR from "swr";

export const useProductions = (searchQuery) => {
    const clientsKey = searchQuery ? `/productions/search-productions?searchParams=${searchQuery}` : `/productions`;
    const { data, error, mutate } = useSWR(clientsKey);

    return {
        productions: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};